export default __webpack_public_path__ + "static/media/Rectangle 79.e5a47df4.svg";